import { forwardRef } from "react"
import { Inspect } from "lucide-react"
import { SearchResult } from "../../../types"
import If from "../if"
import { useAppSelector } from "../../hooks"
import { selectUserDetails } from "../../../redux/slices/auth"

interface Props {
  data: SearchResult
  isAdmin: boolean
  isFirstItem: boolean
  isActive: boolean
  onClickItem: (result: SearchResult) => void
  handleMasquerade: (loid: string) => void
  closeModal: () => void
  onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => void
}

const SearchResultItem = forwardRef<HTMLDivElement, Props>(
  (
    {
      data,
      isAdmin,
      isFirstItem,
      isActive,
      onClickItem,
      handleMasquerade,
      closeModal,
      onKeyDown
    },
    ref
  ) => {
    const user = useAppSelector(selectUserDetails)

    const showMasquerade =
      isAdmin && data.type === "loan_officer" && user?.is_masq !== "1"

    const onMasquerade = () => {
      handleMasquerade(data.id)
      closeModal()
    }

    return (
      <>
        {isFirstItem && (
          <div className="py-2 px-6 font-medium text-sm border-b bg-neutral-100 first-letter:uppercase">
            {data.type.split("_").join(" ")}s
          </div>
        )}
        <div
          ref={ref}
          role="option"
          aria-selected={isActive}
          tabIndex={-1}
          onClick={() => onClickItem(data)}
          onKeyDown={onKeyDown}
          className={`text-sm flex justify-between py-2 px-6 border-b border-neutral-100 cursor-pointer hover:bg-primary-400 hover:text-white transition-colors focus:outline-none ${
            isActive ? "bg-primary-400 text-white" : "bg-white"
          }`}
        >
          <div className="flex-1">{data.item}</div>
          <If
            condition={showMasquerade}
            then={
              <div
                className="flex items-center"
                onClick={e => {
                  e.stopPropagation()
                  onMasquerade()
                }}
              >
                <Inspect size={16} />
                <span className="ml-2">Masquerade</span>
              </div>
            }
          />
        </div>
      </>
    )
  }
)

SearchResultItem.displayName = "SearchResultItem"

export default SearchResultItem
